/**
 * FRONTEND: Citas de Erizos - Lógica del Formulario
 */

// CONFIGURACIÓN (URL de la WebApp de Apps Script desplegada)
const WEB_APP_URL = "https://script.google.com/macros/s/AKfycbx_lR5zLehYWb4V5zewTTKupuK5bfyxiMcIn-5ZuN-QguEmNjsiKe5KT_Nl4a-fdfjZvw/exec";

const HedgehogForm = {
    map: null,
    marker: null,
    selectedPhotos: [], // Array de objetos { file: File, preview: string, processed: string (base64) }

    initialized: false,
    init() {
        if (this.initialized) return;

        // Verificación de seguridad: Asegurarse de que la API de Google Maps esté completamente cargada
        if (!window.google || !window.google.maps || !window.google.maps.Map) {
            // No hacemos nada, el callback initMap se encargará cuando esté lista
            return;
        }

        this.setupMap();
        this.setupEventListeners();
        this.setupPhotoHandling();
        this.setupStepper();
        this.updateConsentVisibility();
        this.initialized = true;
    },

    updateConsentVisibility() {
        const consentSection = document.getElementById("consent-section");
        const consentCheckbox = document.getElementById("consentimiento");
        if (!consentSection || !consentCheckbox) return;

        const hasPhotos = this.selectedPhotos.length > 0;
        if (hasPhotos) {
            consentSection.classList.remove("hidden");
            consentCheckbox.required = true;
        } else {
            consentSection.classList.add("hidden");
            consentCheckbox.required = false;
            consentCheckbox.checked = false;
        }
    },

    // --- GOOGLE MAPS ---
    setupMap() {
        const defaultPos = { lat: 36.834, lng: -2.463 }; // Almería por defecto

        this.map = new google.maps.Map(document.getElementById("map-picker"), {
            center: defaultPos,
            zoom: 7,
            mapId: "948ee635d3a99da7d5827b79",
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false
        });

        this.marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            gmpDraggable: true,
            title: "Ubicación del avistamiento"
        });

        // Selector de tipo de mapa (Píldora personalizada)
        this.createCustomMapControl();

        // Eventos del mapa
        this.map.addListener("click", (e) => {
            this.updateMarkerPosition(e.latLng);
        });

        this.marker.addListener("dragend", () => {
            // Usar setTimeout(0) para asegurar que AdvancedMarkerElement
            // haya finalizado de actualizar su posición interna tras el drag
            setTimeout(() => {
                this.updateMarkerPosition(this.marker.position);
            }, 0);
        });
    },

    createCustomMapControl() {
        const controlDiv = document.createElement("div");
        controlDiv.className = "map-type-pill";

        const types = [
            { id: "roadmap", label: "Mapa" },
            { id: "satellite", label: "Satélite" },
            { id: "hybrid", label: "Híbrido" }
        ];

        const buttons = [];
        types.forEach(type => {
            const button = document.createElement("button");
            button.innerText = type.label;
            button.type = "button";
            if (type.id === "roadmap") button.classList.add("active");

            button.addEventListener("click", () => {
                this.map.setMapTypeId(type.id);
                buttons.forEach(b => b.classList.remove("active"));
                button.classList.add("active");
            });

            buttons.push(button);
            controlDiv.appendChild(button);
        });

        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(controlDiv);
    },

    updateMarkerPosition(latLng) {
        if (!latLng) return;
        this.marker.position = latLng;

        const lat = typeof latLng.lat === "function" ? latLng.lat() : latLng.lat;
        const lng = typeof latLng.lng === "function" ? latLng.lng() : latLng.lng;

        document.getElementById("form-lat").value = lat.toFixed(6);
        document.getElementById("form-lng").value = lng.toFixed(6);
        document.getElementById("form-map-link").value = `https://www.google.com/maps?q=${lat},${lng}&ll=${lat},${lng}&z=17`;
    },

    // --- EVENT LISTENERS ---
    setupEventListeners() {
        const form = document.getElementById("hedgehog-form");
        const atropelloRadios = document.getElementsByName("atropello");
        const actividadContainer = document.getElementById("actividad-container");

        // Lógica condicional: Actividad (solo si NO es atropello)
        atropelloRadios.forEach(radio => {
            radio.addEventListener("change", () => {
                if (radio.value === "No" && radio.checked) {
                    actividadContainer.classList.remove("hidden");
                } else {
                    actividadContainer.classList.add("hidden");
                }
            });
        });

        // Envío del formulario
        form.addEventListener("submit", (e) => this.handleSubmit(e));
    },

    setupStepper() {
        const minus = document.querySelector(".stepper-btn.minus");
        const plus = document.querySelector(".stepper-btn.plus");
        const input = document.getElementById("cantidad");

        if (!minus || !plus || !input) return;

        minus.addEventListener("click", () => {
            let val = parseInt(input.value) || 1;
            if (val > 1) input.value = val - 1;
        });

        plus.addEventListener("click", () => {
            let val = parseInt(input.value) || 1;
            input.value = val + 1;
        });

        // Validar entrada manual
        input.addEventListener("change", () => {
            let val = parseInt(input.value);
            if (isNaN(val) || val < 1) {
                input.value = 1;
            } else {
                input.value = Math.floor(val);
            }
        });
    },

    // --- FOTOS: RESIZE & COMPRESS ---
    setupPhotoHandling() {
        const input = document.getElementById("photo-input");
        const dropzone = document.getElementById("dropzone");

        input.addEventListener("change", (e) => this.handleFileSelection(e.target.files));

        dropzone.addEventListener("dragover", (e) => {
            e.preventDefault();
            dropzone.style.borderColor = "var(--primary)";
        });

        dropzone.addEventListener("dragleave", () => {
            dropzone.style.borderColor = "var(--border)";
        });

        dropzone.addEventListener("drop", (e) => {
            e.preventDefault();
            dropzone.style.borderColor = "var(--border)";
            this.handleFileSelection(e.dataTransfer.files);
        });
    },

    async handleFileSelection(files) {
        const maxPhotos = 5;
        const remaining = maxPhotos - this.selectedPhotos.length;

        const filesToProcess = Array.from(files).slice(0, remaining);

        for (const file of filesToProcess) {
            const preview = URL.createObjectURL(file);
            const processedBase64 = await this.processImage(file);

            this.selectedPhotos.push({ file, preview, processed: processedBase64 });
        }

        this.renderPreviews();
    },

    processImage(file) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    let width = img.width;
                    let height = img.height;
                    const maxDim = 1920;

                    if (width > height) {
                        if (width > maxDim) {
                            height *= maxDim / width;
                            width = maxDim;
                        }
                    } else {
                        if (height > maxDim) {
                            width *= maxDim / height;
                            height = maxDim;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, width, height);

                    // Comprimir a JPEG con calidad 0.8
                    resolve(canvas.toDataURL("image/jpeg", 0.8));
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        });
    },

    renderPreviews() {
        const grid = document.getElementById("photo-preview-grid");
        grid.innerHTML = "";

        this.selectedPhotos.forEach((photo, index) => {
            const item = document.createElement("div");
            item.className = "preview-item";
            item.innerHTML = `
                <img src="${photo.preview}" alt="Vista previa">
                <button type="button" class="remove-photo" data-index="${index}" title="Eliminar foto">
                    <i class="fa-solid fa-trash-can"></i>
                </button>
            `;
            grid.appendChild(item);
        });

        // Eventos para eliminar
        grid.querySelectorAll(".remove-photo").forEach(btn => {
            btn.addEventListener("click", (e) => {
                const idx = parseInt(e.currentTarget.dataset.index);
                // Liberar el ObjectURL para evitar fugas de memoria
                URL.revokeObjectURL(this.selectedPhotos[idx].preview);
                this.selectedPhotos.splice(idx, 1);
                this.renderPreviews();
            });
        });

        this.updateConsentVisibility();
    },

    // --- ENVÍO ---
    async handleSubmit(e) {
        e.preventDefault();

        const form = e.target;
        const submitBtn = document.getElementById("submit-btn");
        const progressContainer = document.getElementById("progress-container");
        const progressBar = document.getElementById("progress-bar-fill");
        const msgDiv = document.getElementById("form-message");

        // Sincronización forzada ANTES de cualquier validación:
        // Asegurar que los inputs hidden tienen la posición actual del marcador
        if (this.marker && this.marker.position) {
            this.updateMarkerPosition(this.marker.position);
        }

        // Validación mapa: comprobar que lat/lng son números válidos (no vacíos, no NaN)
        const latVal = parseFloat(document.getElementById("form-lat").value);
        const lngVal = parseFloat(document.getElementById("form-lng").value);
        if (isNaN(latVal) || isNaN(lngVal)) {
            alert("Por favor, marca la ubicación en el mapa.");
            return;
        }

        const hasPhotos = this.selectedPhotos.length > 0;

        // Bloquear UI
        submitBtn.disabled = true;
        submitBtn.querySelector("span").innerText = "Enviando...";
        if (hasPhotos) {
            progressContainer.classList.remove("hidden");
            progressBar.style.width = "0%";
        } else {
            progressContainer.classList.add("hidden");
        }
        msgDiv.classList.add("hidden");

        // Construir Payload
        const formData = new FormData(form);
        const payload = {};
        formData.forEach((value, key) => {
            payload[key] = value;
        });

        // Sobreescribir lat/lng en el payload con los valores numéricos ya validados
        // (por si FormData leyó algún valor residual de un submit anterior)
        payload.lat = latVal.toFixed(6);
        payload.lng = lngVal.toFixed(6);

        // Añadir fotos procesadas
        payload.photos = this.selectedPhotos.map(p => p.processed);

        // Simulación de progreso (Apps Script no soporta upload progress real con fetch fácilmente)
        // Pero podemos animar la barra mientras esperamos la respuesta si hay fotos
        let interval = null;
        if (hasPhotos) {
            let progress = 0;
            interval = setInterval(() => {
                progress += (100 - progress) * 0.1;
                progressBar.style.width = `${progress}%`;
            }, 300);
        }

        try {
            // Diagnóstico: muestra en consola las coordenadas enviadas para facilitar depuración
            console.log("[Erizos] Enviando coordenadas →", { lat: payload.lat, lng: payload.lng, mapLink: payload.mapLink });

            const response = await fetch(WEB_APP_URL, {
                method: "POST",
                mode: "no-cors", // Requerido para Apps Script si no hay CORS configurado
                headers: {
                    "Content-Type": "text/plain;charset=utf-8"
                },
                body: JSON.stringify(payload)
            });

            // Con no-cors no podemos ver el body si es error, pero asumimos éxito si no hay excepción
            if (interval) clearInterval(interval);
            if (hasPhotos) progressBar.style.width = "100%";

            msgDiv.innerText = "¡Cita enviada con éxito! Muchas gracias.";
            msgDiv.className = "form-message success";
            msgDiv.classList.remove("hidden");

            form.reset();
            // Revocar todos los ObjectURLs antes de vaciar el array
            this.selectedPhotos.forEach(p => URL.revokeObjectURL(p.preview));
            this.selectedPhotos = [];
            this.renderPreviews();
            this.marker.position = null;
            document.getElementById("actividad-container").classList.add("hidden");

        } catch (error) {
            if (interval) clearInterval(interval);
            console.error(error);
            msgDiv.innerText = "Hubo un error al enviar. Inténtalo de nuevo.";
            msgDiv.className = "form-message error";
            msgDiv.classList.remove("hidden");
        } finally {
            submitBtn.disabled = false;
            submitBtn.querySelector("span").innerText = "Enviar Avistamiento";
            if (hasPhotos) {
                setTimeout(() => {
                    progressContainer.classList.add("hidden");
                    progressBar.style.width = "0%";
                }, 3000);
            } else {
                progressContainer.classList.add("hidden");
                progressBar.style.width = "0%";
            }
        }
    }
};

// Exponer globalmente para el callback de Google Maps
window.hedgehogMap = HedgehogForm;

// Intentar inicializar en diferentes momentos para cubrir todas las posibilidades
document.addEventListener("DOMContentLoaded", () => {
    HedgehogForm.init();
});

// Por si el script carga después de que la API de Google Maps ya esté lista
if (window.google && window.google.maps && window.google.maps.Map) {
    HedgehogForm.init();
}
